export default __webpack_public_path__ + "static/media/ejjadh-logo.35f66063.png";